import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Dimensions } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import CumulativeChart from '../../../../../../../src/components/common/cumulative-chart';
import Text, { H3 } from '../../../../../../../src/components/common/text';
import BlurModal from '../../../../../../../src/components/common/blur-modal';
import PortfolioCircularChart from '../../../../../../../src/screens/portfolio/dashboard/portfolio-circular-chart';
import PortfolioTimeChart from '../../../../../../../src/screens/portfolio/dashboard/portfolio-time-chart';
import CurrencyExposureChart from '../../../../../../../src/screens/portfolio/dashboard/currency-exposure-chart';
import PortfolioTable from '../../../../../../../src/screens/portfolio/dashboard/portfolio-table';
import SortingHeader from '../../../../../../../src/components/common/sorting-header';
import ui from '../../../../data/ui.json';
import { Tabs, Tab } from '@dbk/ui-tabs';
import Responsive from '../../../../../../../src/components/common/responsive-dimension-values';
import { isMobile } from "../../../../../../../src/constants";
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import range from 'lodash/fp/range';
import config from '../../../../../../../src/data/settings.json';
import { PALETTE, RM_REGION, ASSET_TAB_ICON_STYLE, KEY_CODE } from '../../../../constants';
import envConfig from '../../../../../../../db-env-build';
import { PORTFOLIO_RELIDTYPE } from '../../../../../../../src/constants';
import { WealthStructuring, PositiveDevelopment, ReviewingandChangingInvestmentOutlook, OutperformanceThroughSelection} from '@dbk/ui-icons';
import CurrencyList from '../../../../../../../src/components/common/currency-list';
import { Large, Small } from '@dbk/ui-text';

const TABS_SMALL = 'small';
const TABS_NORMAL = 'normal';

const TAB_ASSETS = 'assets';
const TAB_PERFORMANCE = 'performance';
const TAB_VALUATION = 'valuation';
const TAB_CURRENCIES = 'currencies';

const tabsTextData = {
  [TABS_SMALL]: new Map([
    ['0', TAB_PERFORMANCE],
    ['1', TAB_VALUATION],
    ['2', TAB_CURRENCIES],
  ]),
  [TABS_NORMAL]: new Map([
    ['0', TAB_ASSETS],
    ['1', TAB_PERFORMANCE],
    ['2', TAB_VALUATION],
    ['3', TAB_CURRENCIES]
  ])
};


const TABS_NAME = {
  [TAB_ASSETS]: 0,
  [TAB_PERFORMANCE]: 1,
  [TAB_VALUATION]: 2,
  [TAB_CURRENCIES]: 3,
};

class PortfolioCharts extends PureComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      timeline: 0,
      selectedInteractionValue: null,
      modal: false,
      doneVisible: true,
      modalContentType: '',
      mediumClassForZoom : false
     
    };
   
    // this.onSelectTab = this.onSelectTab.bind(this);
    this.handleInteractionChange = this.handleInteractionChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);

  }

  toggleModal(pageType) {
    this.setState({
      modal: !this.state.modal,
      modalContentType: pageType,
    });
  }

  onSelectTab = (options, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.setState({ timeline: options });
      this.props.auth.setAssetSelectedIndex(options);
    }
  }

  handleInteractionChange(value) {
    this.setState({
      selectedInteractionValue: value,
    });
  }

  modalContent(messages) {
    const { modalContentType } = this.state;
    // const { i18n: {messages} } = this.props;
    // let remoteUrl = URLResolver.getRemoteURL();
    const remoteUrl = config.environments.relative.remoteUrl;
    if (modalContentType === 'faq') {
      let url = '';
      let title = '';
      const height = $(window).height() - 300;
      if (modalContentType === 'faq') {
        title = messages['app.login.faq']
        if (envConfig.rmRegion === RM_REGION) {
          url = ui.pdf.faq.replace("CH", "LUX");
        } else {
          url = ui.pdf.faq
        }
      } else {
        title = messages['app.login.securityTips']
        if (envConfig.rmRegion === RM_REGION) {
          url = ui.pdf.securityTips.replace("CH", "LUX");
        } else {
          url = ui.pdf.securityTips;
        }
      }
      // let hostname = window.location.hostname;
      // let data =   "https://" + hostname +"/ebanking"+url;
      const data = remoteUrl + url;
      return (
        <div>
          <div className="row">
            <div className="small-12 columns ">
              <H3>{title}</H3>
            </div>
          </div>
          <div className="row">
            <div className="small-12 columns">
              <iframe frameBorder='0' height={height} width='100%' src={data} allowFullScreen />
            </div>
          </div>
        </div>
      );
    }

    return (<Text>{messages['app.profile.consolidatesetup.dataRes']}</Text>);
  }
  renderTabsOptions(tabsType) {

    return this.getTabsOptions(tabsType).map(TabData => (
      <Tab onKeyDown={(event) => this.onSelectTab(TabData.value, event)} testID={"tab_portfolio_portfolioCharts_test_" + TabData.value} key={TabData.value} renderLabel={() => TabData.Component} className="asset-tab tabFocus">
        <div className={`small-12 cell column margin-top-20 asset-container ${(TabData.value === TABS_NAME.performance || TabData.value === TABS_NAME.valuation) ? 'chartWidthClass' : ""}`}>
          {this.getTabContentFactory(TabData.value, tabsType)}
        </div>
        
      </Tab>
    ))
  }

  getTabContentFactory(tabIndex, tabsType) {
    const isSmallScreen = () => tabsType === TABS_SMALL;

    switch (tabIndex) {
      case TABS_NAME[TAB_ASSETS]: {
        return !isSmallScreen() ? this.renderAssets() : this.renderPerformance();
      }
      case TABS_NAME[TAB_PERFORMANCE]: {
        return this.renderPerformance();
      }
      case TABS_NAME[TAB_VALUATION]: {
        return this.renderValuation();
      }
      case TABS_NAME[TAB_CURRENCIES]: {
        return this.renderCurrencies();
      }
    }
  }

  getTabsOptions(tabsType) {
    const { messages } = this.props;
    const tabsData = tabsTextData[tabsType];
    const totalTabs = tabsData.size;
    const textSize = screen.isMedium ? "small" : "normal";
    return flow(range(_), map((value, key) => ({
      Component: (<div className="tab-labels-container" onKeyDown={(event) => this.onSelectTab(value, event)}> {this.getTabIcons(value, tabsType)}
        <div className="tab-labels">
          {messages[`app.portfolio.${tabsData.get(value.toString())}`]}
        </div> </div>),
      value
    })))(totalTabs)
  }

  getTabIcons(tabIndex, tabsType) {
    const isSmallScreen = () => tabsType === TABS_SMALL;

    switch (tabIndex) {
      case TABS_NAME[TAB_ASSETS]: {
        return !isSmallScreen() ? <WealthStructuring width={ASSET_TAB_ICON_STYLE.width} height={ASSET_TAB_ICON_STYLE.height}/> : <OutperformanceThroughSelection width={ASSET_TAB_ICON_STYLE.width} height={ASSET_TAB_ICON_STYLE.height}/>;
      }
      case TABS_NAME[TAB_PERFORMANCE]: {
        return <OutperformanceThroughSelection width={ASSET_TAB_ICON_STYLE.width} height={ASSET_TAB_ICON_STYLE.height}/>;
      }
      case TABS_NAME[TAB_VALUATION]: {
        return <ReviewingandChangingInvestmentOutlook width={ASSET_TAB_ICON_STYLE.width} height={ASSET_TAB_ICON_STYLE.height}/>;
      }
      case TABS_NAME[TAB_CURRENCIES]: {
        return <PositiveDevelopment width={ASSET_TAB_ICON_STYLE.width} height={ASSET_TAB_ICON_STYLE.height}/>;
      }
    }
  }

  renderAssets() {
    const { portfolio, selectedPortfolioData } = this.props;
    return (
      <div className="asset-parent widthForAsset">
      <PortfolioCircularChart
        selectedPorfolioItem={this.props.selectedPorfolioItem}
        portfolio={portfolio}
        toggleLegend={this.toggleLegend}
        showLegend={this.state.showLegend}
        onInteractionChange={this.handleInteractionChange}
        selectedPortfolioData={selectedPortfolioData}
        {...this.props}
        />
        <div className="small-12 medium-6 widthForAsset">
          <div className="sorting-header">
            <SortingHeader
              currency={this.props.currency}
              options={this.props.options}
              state={this.props.state}
              messages={this.props.messages}
              enabled
            />
          </div>
          <PortfolioTable
            static={this.props.static}
            selectedPorfolioItem={this.props.selectedPorfolioItem}
            onDataChanged={this.props.onCircularBarClick}
            portfolio={this.props.portfolio}
            deviceInfo={this.props.deviceInfo}
            changePage={this.props.changePage}
            currency={this.props.currency}
            messages={this.props.messages}
          />
        </div>
      </div>
    );
  }

  renderPerformance() {
    const {
      portfolioChartYTD,
      commonCurrency,
      cumulativeData,
      barchartData,
      selectedPortfolioData,
      messages,
      userprofile: {baseCurrency}
    } = this.props;

    const { selectedInteractionValue } = this.state;
    const displayedCurrency = commonCurrency || baseCurrency;

    if (this.state.timeline == TABS_NAME.performance && (selectedPortfolioData.relIdType === PORTFOLIO_RELIDTYPE.ALL_PORTFOLIOS || selectedPortfolioData.relIdType === PORTFOLIO_RELIDTYPE.CONSOLIDATED )) {
      return (
        <View 
         testID="static-data"
         className="text-center">
        <Large tabIndex={0} role="alert" aria-label={messages['app.portfolio.entity.selection']}>{messages['app.portfolio.entity.selection']}</Large>
      </View>
    )} 

    return (
      <div className="performance-chart-container">
        <CumulativeChart cumulativeData={cumulativeData}
          bars={barchartData}
          selectedInteractionValue={selectedInteractionValue}
          onInteractionChange={this.handleInteractionChange}
          displayedCurrency = {displayedCurrency}
          perfStartDate = {portfolioChartYTD && portfolioChartYTD[0].minPerfDate}
        />
      </div>
    );
  }
  renderValuation() {
    const { portfolio, messages, selectedPortfolioData, auth : { langCode } } = this.props;
    if (this.state.timeline == TABS_NAME.valuation && (selectedPortfolioData.relIdType === PORTFOLIO_RELIDTYPE.ALL_PORTFOLIOS || selectedPortfolioData.relIdType === PORTFOLIO_RELIDTYPE.CONSOLIDATED )) {
      return (
        <View
         testID="static-data"
         className="text-center">
        <Large tabIndex={0} role="alert" aria-label={messages['app.portfolio.entity.selection']}>{messages['app.portfolio.entity.selection']}</Large>
      </View>
    )} 
    return (
      <View>
        <PortfolioTimeChart
          portfolio={portfolio}
          messages={messages}
          langCode={langCode}
        />
      </View>
    );
  }
  toggleLegend = () => {
    this.setState({
      showLegend: !this.state.showLegend,
    })
  };
  renderCurrencies() {
    const { currencyChartData, currency, messages,portfolio, selectedPortfolioData } = this.props;
    if (!currencyChartData){
    return (
      <div className="currencyChartNoData">
      <Large  tabIndex={0} role="alert" aria-label= {messages['app.portfolio.dashboard.currencies']}>
        {messages['app.portfolio.dashboard.currencies']}
      </Large>
    </div>
    )} 
    return (
      <div className="small-12 row">
        <div className="small-6 medium-6 column currency-chart-container widthForAsset">
          <Small className="total-market-value-chart" secondary >{messages['app.portfolio.currencyChart.total.title']}</Small>
          <CurrencyExposureChart currencyChartData={currencyChartData}
            referenceCurrency={currency} />

          <div className="currency-disclaimer">{messages['app.portfolio.currencydisclaimer']}
            <a href="javascript:;" id="FAQ" role="link" style={{ color: PALETTE.primaryActive, cursor: 'pointer' }} onClick={() => this.props.changePage('/login-faq')} >{messages['app.login.faq']}</a>
            {messages['app.portfolio.currencydisclaimertext']}
          </div>
        </div>
        <div className="small-6 medium-6 column currency-list-container widthForAsset">
          <CurrencyList currencyChartData={currencyChartData} referenceCurrency={currency} messages={messages} />
        </div>

       
      </div>
    )
  }
  render() {
    const clear = '';
    let switchTextSize;
    const { cumulativeData, barchartData, currencyChartData, deviceInfo, screen, portfolioChartYTD, commonCurrency, messages } = this.props;
    const { selectedInteractionValue, timeline } = this.state;
    // var abc = JSON.parse(this.props.performanceInfoData);
    if (screen.isMedium) {
      switchTextSize = 'xxsmall';
    } else {
      switchTextSize = 'small';
    }

    // show-for-small-only is for Mobile & hide-for-small-only is for web view or tablet view
    if (screen.isSmall) {
      return (
        <span className="margin-top-20">
          <div className="clearfix">
            <div className="row">
              <div className="small-12 medium-5 column">
                <div className="margin-10">
                  <Tabs className="tabFocus" stretch tabIndex="0" secondary 
                    onKeyDown={(event) => this.onSelectTab(event)}
                    handleSelectedIndex={this.onSelectTab}
                    selectedIndex={timeline}>
                    {this.renderTabsOptions(isMobile(Responsive.windowWidth) ? TABS_SMALL : TABS_NORMAL)}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
          <BlurModal
            onDone={this.toggleModal}
            visible={this.state.modal}
            doneVisible={this.state.doneVisible} >
            {this.modalContent(messages)}
          </BlurModal>
        </span>
      );
    } else if (!screen.isSmall) {
      return (
        <span className="margin-top-20">
          <div className="clearfix">
            <div>
              <div className="small-12 medium-12 column">
                <div> 
               {/* Removed classname= "margin-10" to get view inline with the widget */}
               {/* assetTabSelectedIndex to persist the state of sub-tab WMCE- 7482*/}
                  <Tabs
                    stretch secondary 
                    handleSelectedIndex={(index) => this.onSelectTab(index)}
                    selectedIndex={this.props.auth.assetTabSelectedIndex} 
                    className="tab-bg-color tabHeight">
                    {this.renderTabsOptions(isMobile(Responsive.windowWidth) ? TABS_SMALL : TABS_NORMAL)}
                  </Tabs>
                </div>
              </div>
              {/* <div className="small-12 medium-7 column">
                <div className="margin-10" />
                <div className="small-12 medium-12 column">
                  <SortingHeader
                    currency={this.props.currency}
                    options={this.props.options}
                    state={this.props.state}
                    messages={messages}
                    enabled
                  />


                  <PortfolioTable
                    static={this.props.static}
                    selectedPorfolioItem={this.props.selectedPorfolioItem}
                    onDataChanged={this.props.onCircularBarClick}
                    portfolio={this.props.portfolio}
                    deviceInfo={deviceInfo}
                    changePage={this.props.changePage}
                    currency={this.props.currency}
                    messages={messages}
                  />

                </div>
              </div> */}
            </div>
          </div>
          <BlurModal
            onDone={this.toggleModal}
            visible={this.state.modal}
            doneVisible={this.state.doneVisible} >
            {this.modalContent(messages)}
          </BlurModal>
        </span>
      );
    }
  }
}

PortfolioCharts.propTypes = {
  portfolio: PropTypes.object,
  selectedPortfolioData: PropTypes.object,
  portfoliosData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    relId: PropTypes.string,
  })),
  changePortfolio: PropTypes.func.isRequired,
  changePortfolioData: PropTypes.func,
  changePage: PropTypes.func.isRequired,
  onDragStart: PropTypes.func,
  onDragMove: PropTypes.func,
  onDragEnd: PropTypes.func,
  deviceInfo: PropTypes.object,
  cumulativeData: PropTypes.arrayOf(PropTypes.shape({
    titleText: PropTypes.string,
    valueText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.number,
    incYear: PropTypes.number
  })),
  barchartData: PropTypes.arrayOf(PropTypes.shape({
    titleText: PropTypes.string,
    valueText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.number,
    incYear: PropTypes.number
  })),
  currencyChartData: PropTypes.string,
  parentDimentions: PropTypes.number,
  onCircularBarClick: PropTypes.func
};

export default createContainer({
  $queries: {
    auth:{
      assetTabSelectedIndex: true,
      setAssetSelectedIndex: { $set: 'assetTabSelectedIndex' },
      langCode: true
    },
    userprofile: {
      baseCurrency: true
    },
  },
  $fragments: {
    portfolio: {
      ...PortfolioCircularChart.getFragment('portfolio'),
      ...PortfolioTimeChart.getFragment('portfolio'),
      ...PortfolioTable.getFragment('portfolio'),
    },
    portfolios: {
      ...PortfolioCircularChart.getFragment('portfolios'),
    },

  },
})(PortfolioCharts);
